import { createContext } from "react";

export const DEFAULT_STATE = {
  showPopup: false,
  // Set this up programmatically
  filterOptions: {},
  filterConfig: {},
  selectedPractitioner: null,
  initialAnswer: null,
  slot: null,
};
export const GlobalContext = createContext();
